import classNames from "classnames";
import React, { ReactNode } from "react";
import Link from "../Link";

export interface Props {
  title: string | ReactNode;
  href: string;
  target?: string;
  className?: string;
  onClick?: any;
  disabled?: boolean;
  type?: string;
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  large?: boolean;
}

const BlockButton = ({ title, href, className, ...props }: Props) => {
  return (
    <Link
      {...props}
      to={href}
      className={classNames(
        "group inline-flex items-center space-x-3 bg-brand py-2 pl-3 pr-2 hover:bg-white",
        className
      )}
    >
      <p className="font-title text-base text-black group-hover:underline">
        {title}
      </p>
      <div className="button-box button-black-brand" aria-hidden>
        -&gt;
      </div>
    </Link>
  );
};

export default BlockButton;
